export interface VideoAd {
  id: number;
  name: string;
  title: string;
  contentUrl: string;
  skippable: boolean;
  skippableAfterSeconds: number;
  muted: boolean;
  type: "pre_roll" | "mid_roll" | "post_roll";
  viewabilityTracking: boolean;
  processed: boolean;
  status: "pending" | "active" | "deleted" | "src_issue";
  profileId: number;
  languageCodeId: number;
  createdAt: string;
  updatedAt: string;
}

export function validateVideoAd(videoAd: Omit<VideoAd, "id" | "createdAt" | "updatedAt">) {
  const errors: Partial<Record<keyof VideoAd, string>> = {};

  if (!videoAd?.name) {
    errors.name = "Name is required";
  } else if (videoAd.name.length > 255) {
    errors.name = "Name is too long";
  }

  if (!videoAd?.title) {
    errors.title = "Title is required";
  } else if (videoAd.title.length > 255) {
    errors.title = "Title is too long";
  }

  if (!videoAd?.contentUrl) {
    errors.contentUrl = "Content URL is required";
  } else if (videoAd.contentUrl.length > 255) {
    errors.contentUrl = "Content URL is too long";
  }

  return errors;
}